import { LockOpenPlusOutlineIcon } from './LockOpenPlusOutlineIcon';

/**
 * author: Colton Wiscombe
 * id 804F39C9-F4EB-4663-8EA6-67F668C8CCDF
 * name lock-open-plus-outline
 * version: 5.8.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/lock-open-plus-outline.svg
 * tags
 * - Lock 
 */
export const LockOpenAddOutlineIcon = LockOpenPlusOutlineIcon;
export default LockOpenAddOutlineIcon